import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { AudioMessage as AudioMessageModal } from '../../modals/audioMessage';
import { useAnnouncementName } from './callback';
const translatePayload = (node) => {
    const { hangUpAfterAnnouncement, afterAnnouncementNodeId } = node.payload;
    return !hangUpAfterAnnouncement
        ? [
            {
                id: uuid(),
                connection: afterAnnouncementNodeId || uuid(),
                label: 'arrow',
            },
        ]
        : [];
};
const updateConnection = (node, _connection, connectionId) => {
    const payload = Object.assign(Object.assign({}, node.payload), { hangUpAfterAnnouncement: false, afterAnnouncementNodeId: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
export const AudioMessageNodeAttributes = {
    iconName: 'announcement',
    label: 'Audio message',
    helpText: 'Record or upload an audio message that’ll play when your customers call you (e.g. informing them when you’re closed for the holidays, asking to have an order number ready, etc.).',
    color: hexStringToNumber(flowNodeColor.red),
    translatePayload,
    updateConnection,
    NodeContent: AudioMessageNode,
    ActionModal: AudioMessageModal,
};
export function AudioMessageNode({ node, context, }) {
    const { extraData } = context;
    const { payload } = node;
    const announcement = useAnnouncementName(payload.announcement, extraData);
    return (_jsx(TextContent, { children: useMemo(() => (_jsx(_Fragment, { children: _jsxs(TextEllipsis, { children: [_jsx(Text, { weight: "normal", text: "Audio file" }), _jsx(Text, { weight: "semibold", text: announcement })] }) })), [announcement]) }));
}
